import React, { useState } from 'react';
import { updateEmployeeDetails } from '../../services/adminService';
import './CreateEmployeeModal.css';

const EditEmployeeModal = ({ employee, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: employee.name || '',
    email: employee.email || '',
    salary: employee.salary || '',
    workHours: employee.workHours || '',
    employeeType: employee.employeeType || 'Full Time',
    designation: employee.designation || '',
    department: employee.department || 'General',
    employeeId: employee.employeeId || employee._id.substring(0, 8).toUpperCase(),
    dateOfJoining: employee.dateOfJoining ? new Date(employee.dateOfJoining).toISOString().split('T')[0] : '',
    bankName: employee.bankName || '',
    accountNo: employee.accountNo || '',
    panNumber: employee.panNumber || '',
    uanNumber: employee.uanNumber || ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const allDesignations = [
    'Software Engineer', 'Senior Software Engineer', 'Frontend Developer',
    'Backend Developer', 'Full Stack Developer', 'Project Manager',
    'Product Manager', 'UI/UX Designer', 'HR Manager', 'QA Engineer',
    'Marketing Manager', 'Sales Executive', 'Data Analyst', 'DevOps Engineer'
  ];

  const allDepartments = [
    'Engineering', 'Product', 'Design', 'HR', 'Marketing', 'Sales', 'General', 'Development QA', 'Operations', 'Finance', 'Support'
  ];

  const [filteredDesignations, setFilteredDesignations] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [showDeptSuggestions, setShowDeptSuggestions] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    if (name === 'designation') {
      if (value.trim()) {
        const filtered = allDesignations.filter(d =>
          d.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredDesignations(filtered);
        setShowSuggestions(true);
      } else {
        setFilteredDesignations([]);
        setShowSuggestions(false);
      }
    }

    if (name === 'department') {
      if (value.trim()) {
        const filtered = allDepartments.filter(d =>
          d.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredDepartments(filtered);
        setShowDeptSuggestions(true);
      } else {
        setFilteredDepartments([]);
        setShowDeptSuggestions(false);
      }
    }
  };

  const handleSuggestionClick = (designation) => {
    setFormData({ ...formData, designation });
    setShowSuggestions(false);
  };

  const handleDeptSuggestionClick = (department) => {
    setFormData({ ...formData, department });
    setShowDeptSuggestions(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await updateEmployeeDetails(employee._id, {
        name: formData.name,
        email: formData.email,
        salary: formData.salary ? parseFloat(formData.salary) : 0,
        workHours: formData.workHours ? parseFloat(formData.workHours) : 8,
        employeeType: formData.employeeType,
        designation: formData.designation,
        department: formData.department,
        employeeId: formData.employeeId,
        dateOfJoining: formData.dateOfJoining || null,
        bankName: formData.bankName,
        accountNo: formData.accountNo,
        panNumber: formData.panNumber,
        uanNumber: formData.uanNumber
      });
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Edit Employee Details</h2>
        <form onSubmit={handleSubmit} autoComplete="off">
          {error && <div className="error-message">{error}</div>}
          <div className="modal-body">
            
            <div className="form-group">
              <label>Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Employee name"
              />
            </div>
            <div className="form-group">
              <label>Employee ID *</label>
              <input
                type="text"
                name="employeeId"
                value={formData.employeeId}
                onChange={handleChange}
                required
                placeholder="e.g. EMP001"
              />
            </div>
            <div className="form-group">
              <label>Date of Joining</label>
              <input
                type="date"
                name="dateOfJoining"
                value={formData.dateOfJoining || ''}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="employee@example.com"
              />
            </div>
            <div className="form-group">
              <label>Salary *</label>
              <input
                type="number"
                name="salary"
                value={formData.salary}
                onChange={handleChange}
                placeholder="0"
                min="0"
                step="0.01"
                required
              />
            </div>
            <div className="form-group">
              <label>Work Hours (per day) *</label>
              <input
                type="number"
                name="workHours"
                value={formData.workHours}
                onChange={handleChange}
                placeholder="8"
                min="0"
                max="24"
                step="0.5"
                required
              />
            </div>
            <div className="form-group">
              <label>Employee Type *</label>
              <select
                name="employeeType"
                value={formData.employeeType}
                onChange={handleChange}
                required
              >
                <option value="Full Time">Full Time</option>
                <option value="Intern">Intern</option>
                <option value="Contract">Contract</option>
              </select>
            </div>
            <div className="form-group" style={{ position: 'relative' }}>
              <label>Designation *</label>
              <input
                type="text"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                onFocus={(e) => {
                  if (e.target.value) setShowSuggestions(true);
                }}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                placeholder="Select or Type Designation"
                required
                autoComplete="off"
              />
              {showSuggestions && filteredDesignations.length > 0 && (
                <ul className="suggestions-list">
                  {filteredDesignations.map((role) => (
                    <li key={role} onClick={() => handleSuggestionClick(role)}>
                      {role}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="form-group" style={{ position: 'relative' }}>
              <label>Department *</label>
              <input
                type="text"
                name="department"
                value={formData.department}
                onChange={handleChange}
                onFocus={(e) => {
                  if (e.target.value) setShowDeptSuggestions(true);
                }}
                onBlur={() => setTimeout(() => setShowDeptSuggestions(false), 200)}
                placeholder="Select or Type Department"
                required
                autoComplete="off"
              />
              {showDeptSuggestions && filteredDepartments.length > 0 && (
                <ul className="suggestions-list">
                  {filteredDepartments.map((dept) => (
                    <li key={dept} onClick={() => handleDeptSuggestionClick(dept)}>
                      {dept}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            
            <div className="form-group">
              <label>Bank Name</label>
              <input
                type="text"
                name="bankName"
                value={formData.bankName}
                onChange={handleChange}
                placeholder="Bank Name"
              />
            </div>
            <div className="form-group">
              <label>Account No</label>
              <input
                type="text"
                name="accountNo"
                value={formData.accountNo}
                onChange={handleChange}
                placeholder="Account No"
              />
            </div>
            <div className="form-group">
              <label>Pan Number</label>
              <input
                type="text"
                name="panNumber"
                value={formData.panNumber}
                onChange={handleChange}
                placeholder="Pan Number"
              />
            </div>
            <div className="form-group">
              <label>UAN Number</label>
              <input
                type="text"
                name="uanNumber"
                value={formData.uanNumber}
                onChange={handleChange}
                placeholder="UAN Number"
              />
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn-secondary">
              Cancel
            </button>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEmployeeModal;
